import { Customer } from "../../CRUDs/entities/Customer";
import { JobRequest } from "../../CRUDs/entities/JobRequest";
import { SectionSwitcher } from "../SectionSwitcher";
import { SimpleSectionSwitcher } from "../../components/SimpleSectionSwitcher";
import { checkActionAttribute } from "./checkActionAttribute";
import worker_cabinet from "../../worker_cabinet";

import { actionListGenerator } from "./actionListnerGenerator";
import { setQueryParams } from "../Filter";

export const customersModalActionsListners = (target, actionsWindow) => {

    const customerId = target.parent().data('id');
    const staticRequest = new JobRequest();

    const customer = new Customer(customerId);

    checkActionAttribute([
        { attribute: 'data-has-quotes',     className: 'view-quotes' },
        { attribute: 'data-has-requests',   className: 'view-requests' },
        { attribute: 'data-has-jobs',       className: 'view-jobs' },

        { attribute: 'data-has-invoices',   className: 'view-invoices' },
        { attribute: 'data-has-visits',     className: 'view-visits' },
    ], target, actionsWindow);


    actionsWindow.find('.action').off();

    // view requests, quotes, invoices and jobs
    actionsWindow.find('.action.select').not('.customer-orders').on('click', function() {
        const entityClass = $(this).attr('class').split(' ').pop().split('-').pop();

        const sectionSwitcher = new SectionSwitcher();
        const section = sectionSwitcher.showSelectedSection(entityClass).show();

        section.filter.reset();

        setQueryParams({
            'entity_class': entityClass,
            'customer_id': customer.id
        });

        section.filter.main({
            'entity_class': entityClass,
            'customer_id': customer.id
        });

    });

    // create request
    actionsWindow.find('.action.create-request').on('click', (e) => {
        staticRequest.openModal('create', { customer_id: customerId });
    });

    // contact customer
    actionsWindow.find('.action.contact').on('click', (e) => {
        customer.openModal('contact');
    });

    // edit customer
    actionsWindow.find('.action.edit-customer').on('click', (e) => {
        customer.openModal('edit');
    });

    // delete customer
    actionsWindow.find('.action.delete-customer').on('click', (e) => {
        customer.deleteConfirmWindow();
    });

    // view logs
    actionsWindow.find('.action.view-logs').on('click', (e) => {
        customer.openModal('logs');
    });

    actionsWindow.find('.action.customer-orders').on('click', (e) => {
        $.ajax({
            type: 'POST',
            url: '/get_customer_orders',
            data: ({
                id: customer.id,
            }),
            success: function (response) {
                //console.log(response);
                $('#orders-modal-container').html(response);
                $('#customer-orders-modal').modal('show');
            }
        });
    })

    // payment info
    actionsWindow.find('.action.payment-info').on('click', (e) => {
        $.ajax({
            type: 'POST',
            data: ({
                id: customer.id,
            }),
            url: `customers/${customer.id}/payment-info`,
            success: function (response) {
                customer.pasteForm(response);
                $('#form-container .modal').modal('show');
            }
        });
    });

    // send a link to personal cabinet
    actionsWindow.find('.action.link-to-cabinet').on('click', (e) => {
        $('#remind-modal').modal('show');

        $('.remind-link').off();
        const remindUrl = `customers/${customer.id}/remind-cabinet-link`;
        $('.remind-link').on('click', function() {
            $.ajax({
                url: remindUrl,
                method: 'POST',
                data: { notify_method: this.getAttribute('data-notify-method')},
                success: () => { $('#remind-modal').modal('hide'); }
            });
        })
    });

    // send a link to customer profile cab
    actionsWindow.find('.action.profile').on('click', (e) => {
        const info = customer.read();
        let lat =  info.lat;
        let lon =  info.lon;
        $.ajax({
            url: '/worker-cabinet/viewWorkersCard/' + info.id,
            type: 'GET',
            success: function (res) {
                $('#ajax_modals_container').html(res);
                $('#customer-flyer').modal('show');
                $('#customer-flyer').css('padding-right', 0);
                if(lat && !isNaN(lat) && lon && !isNaN(lon)){
                    worker_cabinet.mapInit();
                    worker_cabinet.RouteDisplayMap({
                        lat,
                        lon
                    });
                }

                worker_cabinet.toggleViewAllPictures();
                let switchers = document.querySelectorAll('#customer-flyer .switcher');
                for(let sw of switchers){
                    new SimpleSectionSwitcher(sw)
                }
                worker_cabinet.uploadListener(info.id);
            }
        });
    });


}
